<section class="container">
	<img src="../../../assets/img/{{themeService.theme}}/delegate.svg" alt="Shared Plans" width="150px">
	<h2>About Shared Plans</h2>
	<p>Here you can find all the plans that others have shared with you. <br> You can access each section of a shared
		plan according to the permission level set by the plan’s owner.</p>
	<section class="explanations">
		<div class="rights">
			<div class="div-opacity div-opacity-contributor">
				<i class="fa fas fa-pen-alt contributor-fa"></i>
				<div class="contributor rights-div">Contributor</div>
			</div>

		</div>
		<p>You can add and edit the items stored in this section, so you’ll be able to help the plan owner to build and
			manage their plan.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-now">
				<i class="fa fas fa-eye viewer-now-fa"></i>
				<div class="viewer-now rights-div">Viewer - Now</div>
			</div>

		</div>
		<p>You can view the items stored in this section but cannot make any changes yourself. This means you can get
			swift and easy access to the items in their plan.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-future">
				<i class="fa fas fa-eye viewer-future-fa"></i>
				<div class="viewer-future rights-div">Viewer - Future</div>
			</div>

		</div>
		<p>You can only view the items stored in this section if the plan owner passes away or loses mental capacity. To
			view their plan, you will have to request access from us by clicking the Request button.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-no-access">
				<i class="fa fas fa-lock no-access-fa"></i>
				<div class="no-access rights-div">No Access</div>
			</div>

		</div>
		<p>All items in this section are permanently hidden from you.</p>
	</section>
</section>